import { useCallback, useState } from 'react';

import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { RiArrowRightLine } from '@remixicon/react';

import { RecordingDrawer } from './RecordingDrawer';
import classes from './RecordingsTable.module.css';
import { getRecordingLabel } from './types';
import type { RecordingHit } from './types';

export const RecordingsTable = ({
  recordings,
}: {
  recordings: RecordingHit[];
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const handleClose = useCallback(() => setActiveIndex(null), []);

  return (
    <div className={classes.wrapper}>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>#</TableCell>
            <TableCell className={classes.headerCell}>Session</TableCell>
            <TableCell className={classes.headerCell}>Preview</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recordings.map((recording, index) => (
            <TableRow key={recording.name}>
              <TableCell className={classes.numberCell}>{index + 1}</TableCell>
              <TableCell className={classes.sessionCell}>
                {getRecordingLabel(recording)}
              </TableCell>
              <TableCell>
                <Link
                  component="button"
                  type="button"
                  underline="none"
                  className={classes.watchLink}
                  onClick={() => setActiveIndex(index)}
                >
                  Watch <RiArrowRightLine size={14} />
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <RecordingDrawer
        recordings={recordings}
        activeIndex={activeIndex}
        onClose={handleClose}
        onNavigate={setActiveIndex}
      />
    </div>
  );
};
